/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { noop } from 'lodash';
import cs from 'classnames';

import { Col, Row, Typography } from 'antd';

import { CHANNEL_ITEM_FIELDS, EVENT_CHANNELS_INITS } from './constants';

import { Button, ScheduleDay, Select } from '@atoms';
import { ChannelField } from '@molecules';

import DayForm from './DayForm';
import Form from '../Form';

import s from './styles.module.less';

const AddChannelForm = ({
  initialValues: initData,
  whereToWatchDays,
  countriesList,
  handleClose,
  className,
  onSubmit,
  buttons,
  ref,
}) => {
  const [form] = Form.useForm(CHANNEL_ITEM_FIELDS);
  const initialValues = React.useMemo(
    () =>
      form.deserialize(
        initData || {
          ...EVENT_CHANNELS_INITS,
          days: whereToWatchDays?.map((day) => ({ ...day, countries: [] })) || [],
        },
      ),
    [form, initData, whereToWatchDays],
  );

  const [selectedDayIdx, setSelectedDayIdx] = React.useState(0);
  const [days, setDays] = React.useState(initialValues[CHANNEL_ITEM_FIELDS.DAYS.name]);
  const activeDayValues = React.useMemo(() => days[selectedDayIdx], [days, selectedDayIdx]);

  const onActiveDayChange = React.useCallback(
    (name, value) => {
      const newDaysData = [...days];
      newDaysData[selectedDayIdx][name] = value;
      setDays(newDaysData);
    },
    [selectedDayIdx, days],
  );

  const DaysButtons = React.useCallback(
    () =>
      days?.map(({ day, sessionFirstUrl, sessionSecondUrl }, idx) => {
        const isEmpty = !(sessionFirstUrl && sessionSecondUrl);
        return (
          <ScheduleDay
            className={cs(s.dayBrick, { [s.selectedDay]: idx === selectedDayIdx })}
            onClick={() => setSelectedDayIdx(idx)}
            key={`day-${day}-${idx}`}
            title={`Day ${day}`}
            isEmpty={isEmpty}
            value={idx}
          />
        );
      }),
    [days, setSelectedDayIdx, selectedDayIdx],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
    handleClose();
  }, [handleClose, form]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value);

      handleCancel();
    },
    [onSubmit, handleCancel],
  );

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      layout="vertical"
      form={form}
      ref={ref}
    >
      {buttons && <Typography.Text level={3}>Edit Channel</Typography.Text>}
      {!buttons && <Typography.Title level={3}>Add a new channel</Typography.Title>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <Form.Item {...CHANNEL_ITEM_FIELDS.CATEGORY}>
                <Select {...CHANNEL_ITEM_FIELDS.CATEGORY}>
                  {CHANNEL_ITEM_FIELDS.CATEGORY.options.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <ChannelField {...CHANNEL_ITEM_FIELDS.CHANNEL} wrapperCol={{ span: 24 }} />
            </Col>
          </Row>

          <DaysButtons />
          <DayForm initialValues={activeDayValues} countriesList={countriesList} onChange={onActiveDayChange} />

          <Form.List {...CHANNEL_ITEM_FIELDS.DAYS}>{noop}</Form.List>

          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <>
                  <Button type="primary" style={{ minWidth: 200, marginRight: 20 }} onClick={form.submit}>
                    SAVE
                  </Button>
                  <Button onClick={handleCancel}>CANCEL</Button>
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default AddChannelForm;
